import React from "react";
import { classNames } from "~/utils";

type UnifiedCardHomeProps = {
  name: string;
  imageUrl?: string;
  subtitle?: string;
  layout: "vertical" | "horizontal";
};

const UnifiedCardHome: React.FC<UnifiedCardHomeProps> = ({
  name,
  imageUrl,
  subtitle,
  layout,
}) => {
  const isVertical = layout === "vertical";

  return (
    <div
      className={classNames(
        "overflow-hidden border border-slate-200 bg-white shadow-card transition-all duration-200 hover:bg-gray-100 hover:shadow-lg",
        isVertical ? "rounded-2xl" : "flex h-28 rounded-3xl"
      )}
    >
      <div className="flex-shrink-0">
        {imageUrl ? (
          <img
            src={imageUrl}
            className={classNames(
              isVertical ? "h-36 w-full object-cover" : "h-28 w-44 object-cover"
            )}
            alt=""
          />
        ) : (
          <div
            className={classNames(
              "flex items-center justify-center bg-gray-200",
              isVertical ? "h-36 w-full" : "h-28 w-44"
            )}
          >
            <svg
              className="h-10 w-10 text-gray-400"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z"
              />
            </svg>
          </div>
        )}
      </div>

      <div
        className={classNames(
          isVertical
            ? "p-4"
            : "flex min-w-0 flex-1 flex-col justify-center overflow-hidden px-5 py-3"
        )}
      >
        <h4
          className={classNames(
            "font-bold text-textColor-primary",
            isVertical
              ? "truncate text-sm"
              : "block truncate text-base leading-5"
          )}
        >
          {name}
        </h4>
        {subtitle && (
          <p
            className={classNames(
              "overflow-hidden text-sm text-textColor-light",
              isVertical
                ? "text-ellipsis whitespace-nowrap"
                : "mt-1 block truncate leading-5"
            )}
          >
            {subtitle}
          </p>
        )}
      </div>
    </div>
  );
};

export default UnifiedCardHome;
